// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1949":"6127c8a095069111","3164":"67abf2726a9c53e1","4556":"32e6f08c5a370d28","5261":"c730db16cc6ce76d"}[chunkId] + ".css";
};